// extracted by css-extract-rspack-plugin
var _1 = "c3";
var _2 = "c1";
var _3 = "c5";
var _4 = "cz";
var _5 = "cy";
var _6 = "cs";
var _7 = "ct";
var _8 = "c0";
var _9 = "c4";
var _a = "c6";
var _b = "cu";
var _c = "cv";
var _d = "cw";
var _e = "c2";
var _f = "cx";
var _10 = "cr";
export { _1 as "additionalService", _2 as "additionalServices", _3 as "anchor", _4 as "daysOfWeekRange", _5 as "daysOfWeekRangeHours", _6 as "detailsContent", _7 as "detailsSubContent", _8 as "hours", _9 as "location", _a as "map", _b as "mapLink", _c as "openingHours", _d as "service", _e as "serviceContainer", _f as "serviceTitle", _10 as "shoppingMallTabDetailsComponent" }
